import { DateTime } from 'luxon';
import moment, { Moment } from 'moment';

export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';

const isDate = (value: unknown): value is DateTime =>
  DateTime.isDateTime(value) && value.isValid;

/**
 * Converts an ISO string to a Moment object.
 * Only to be used in conjunction with @spotify-internal/react-dates, which works only with Moment objects
 *
 * @example fromISOToMomentObject('2000-01-01T22:22')) // moment('2000-01-01T22:22')
 * @param isoString
 */
export const fromISOToMomentObject = (isoString: string): Moment | null => {
  return moment(isoString).isValid() ? moment(isoString) : null;
};

/**
 * Formats luxon DateTime to a provided format
 * @example formatDate(DateTime.utc(2000, 1, 1, 22, 22)); // "2000-01-01"
 * @param date
 * @param format - Defaults `to yyyy-MM-dd`
 */
export const formatDate = (
  date?: DateTime,
  format: string = DEFAULT_DATE_FORMAT,
): string | undefined => {
  return isDate(date) ? date.toFormat(format) : undefined;
};

/**
 * Converts a Moment object to an ISO string
 * Only to be used in conjunction with @spotify-internal/react-dates, which works only with Moment objects
 *
 * @example fromMomentObjectToISO(moment('2000-01-01T22:22'))) // '2000-01-01'
 * @param momentObject
 */
export const fromMomentObjectToISO = (
  momentObject?: Moment | null,
): string | undefined => {
  return momentObject
    ? formatDate(DateTime.fromISO(momentObject.toISOString()))
    : undefined;
};
